import { InjectionToken } from '@angular/core';
import { HttpConfig } from '../model/http.model';

export const HTTP_CONFIG = new InjectionToken<HttpConfig>('HTTP_CONFIG');
